// angular
// 	.module("HeroPRO")
// 	.controller("PipelineJobModalController", pipelineJobModalController);

import './pipelineJobModal.scss';

/* @ngInject */
export default function pipelineJobModalController($scope, ModalService, JobFactory, raSpinnerService) {
    const vm = this;
    let jobModal = {};

    vm.isAssignMode = false;

    vm.propertyOwner = '';
    vm.streetAddress = '';
    vm.cityStateZip = '';

    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */

    vm.closeJobModal = function () {
        ModalService.closeLgModal();
        raSpinnerService._unregister('jobSpinner');
    };

    jobModal.result.then(() => {
    }, () => {
        raSpinnerService._unregister('jobSpinner');
    });

    /* -----  End of Public Functions  ------*/

    /*= =======================================
	 =            Private Functions            =
	 ======================================== */
    function init() {
        const job = JobFactory.getActiveJob();
        vm.isAssignMode = JobFactory.getAssignJobFlag();
        if (job.PreQualId !== undefined && job.PreQualId !== null && job.PreQualId !== '') {
            vm.streetAddress = job.Address;
            vm.cityStateZip = job.City;
        } else {
            vm.propertyOwner = `${job.Owner1FirstName} ${job.Owner1LastName}`;
            vm.streetAddress = job.PropertyAddress1;
            vm.cityStateZip = `${job.PropertyCity}, ${job.PropertyState} ${job.PropertyZip}`;
        }

        jobModal = ModalService.getLgModal();
    }
}



// WEBPACK FOOTER //
// ./src/app/pipeline/job/pipelineJobModalController.js